<template>
	<section>
		<div class="container  mgt-30">
			<div class="t-headline10 mgt-50 pdt-6 mgb-16 font-m t-color-headline-black">
				{{ $t('30059') }}
			</div>
			<div v-for="(content, contentIndex) in contents"
			     :key="contentIndex"
			     :class="{'course-list-content' : contents.length > 1 }">
				<div v-if="content.examPaperContents">
					<div class="d-flex mgb-6 align-items-baseline">
						<div class="t-headline7 font-m t-color-headline-black mgr-13" tabindex="0">
							{{ content.examDistribution.name }}
						</div>
						<div class="t-body1 t-color-bodyGrayA l-spacing45 min-w-60 t-right">
							{{ $t('30201', {str: questionCount(content.examDistribution.examPaper.questionGroup)}) }}
						</div>
<!--						<div class="t-body1 t-color-bodyGrayA mgt-6">-->
<!--							{{ content.examDistribution.examPaper.operationTerms.summary }}-->
<!--						</div>-->
					</div>
					<!-- <div class="mdc-card mgb-24"> -->
					<div class="mgb-24">
						<div class="d-flex align-items-center justify-content-between pdb-8 pdr-24">
							<div class="d-flex align-items-center">
								<div class="t-body1 t-color-bodyGrayA font-r l-spacing45">{{ content.examDistribution.examPaper.operationTerms.summary }}</div>
							</div>
						</div>
					</div>
				</div>
				
				<div v-else>
					<div class="d-flex mgb-16">
						<div v-if="content.course.imageUsage === true && content.course.imageList.length > 0"
						     class="position-relative">
							<img :src="content.course.imageList[0].resourceUri"
							     alt=""
							     class="b-radius4 thumb-112">
						</div>
						<div>
							<div class="t-headline7 font-m t-color-headline-black">
								{{ content.course && content.course.name }}
							</div>
							<div v-if="!content.course.learnInfoList.length <= 0" class="t-body1 t-color-bodyGrayA mgt-6">
								{{ getSummary(content.course.learnInfoList) }}
							</div>
						</div>
					</div>
					<Section v-for="(section, index) in content.course && content.course.sections"
					         :is-collapsed="contentIndex > 0 || index > 0"
					         :section="section"
					         @displayFile="displayFile">
					</Section>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import {utilDateMixin} from "@/mixins/dateUtil";
import LessonTab from "@/components/microDegree/view/LessonTab.vue";
import localStorageUtil from "@/utils/localStorageUtil";
import Section from "@/components/microDegree/view/Section";

export default {
	name: "Course",
	
	components: {Section, LessonTab},
	
	props: ['contents'],
	
	mixins: [utilDateMixin],
	
	component: {
		'lesson-tab': () => import('@/components/microDegree/view/LessonTab.vue')
	},
	
	data() {
		return {
			languageInfo: localStorageUtil.getLanguageInfo()
		}
	},
	
	mounted() {
	},
	
	methods: {
		timeFormat(time) {
			return this.$options.filters.timeToDateFormat(time)
		},
		
		isExamPaper(lessons) {
			const paperLen = _.filter(lessons, lesson => {
				return lesson.resourceType.value === 'EXAM'
			})
			return paperLen.length
		},
		
		lessonTypeIcon(val) {
			if (val.exam !== null) {
				return 'calculate'
			}
			if (val.meeting !== null) {
				return 'videocam'
			}
			const valType = val.lcms.type.value;
			switch (valType) {
				case 'COMPUTER_SCIENCE' :
					return 'code';
				case 'VIDEO' :
					return 'play_circle';
				case 'PDF' :
					return 'picture_as_pdf';
				case 'HTML' :
					return 'description';
				case 'INTERACTIVE_HTML' :
					return 'description';
				case 'SLIDE' :
					return 'description';
				case "EXAM":
					return 'grid_view';
				default:
					return 'description';
			}
		},
		
		questionCount(exams) {
			let totalCount = 0;
			_.each(exams, exam => {
				totalCount += exam.questions.length;
			});
			return totalCount;
		},
		
		displayFile(file) {
			this.$emit('displayFile', file);
		},
		
		getSummary(learnInfoList) {
			if (!learnInfoList || !learnInfoList.length) {
				return '';
			}
			const languageInfo = JSON.parse(localStorageUtil.getLanguageInfo());
			const learnInfo = learnInfoList.find(info => info.lang.value === languageInfo.code);
			return learnInfo ? learnInfo.purpose : '';
		}
	}
}
</script>

<style scoped>
.course-list-content {
	padding-left: 68px;
	position: relative;
}

.course-list-content::after {
	position: absolute;
	content: '';
	width: 28px;
	height: 28px;
	border-radius: 50%;
	border: 4px solid var(--Divider);
	background: var(--DocumentWhite);
	top: 0;
	left: 0px;
}

.course-list-content::before {
	position: absolute;
	content: '';
	width: 4px;
	height: calc(100% + 24px);
	background: var(--Divider);
	top: 0;
	left: 16px;
}

.course-list-content:last-child::before {
	display: none;
}
</style>
